
import './SubscriptionScenariosList.css';
import Subscription from "../../../../domain/models/Subscription";
import { useContext, useEffect } from "react";
import SubscriptionEditionFormContext from "../../../contexts/forms/subscriptions/SubscriptionEditionFormContext";
import Card from "antd/es/card/Card";
import ScenariosList from "../../../components/@shared/ScenariosList";
import AIContext from "../../../contexts/data/AIContext";
import { Button, message } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import { ContextStatus } from '@leedpulse-monorepo/enums';

interface SubscriptionScenariosListProps {
    subscription: Subscription;
}

const SubscriptionScenariosList: React.FC<SubscriptionScenariosListProps> = ({
    subscription,
}) => {

    const formContext = useContext(SubscriptionEditionFormContext);
    const aiContext = useContext(AIContext);

    useEffect(() => {
        if (formContext.wipSubscription === null) {
            formContext.initWithSubscription(subscription);
        }
    }, []);

    useEffect(() => {
        switch (formContext.updateStatus) {
            case ContextStatus.SUCCESS:
                message.success("Mise à jour effectuée");
                break;
            case ContextStatus.ERROR:
                message.error("Erreur lors de la mise à jour");
                break;
            default:
                break;
        }
    }, [formContext.updateStatus]);

    const wipSubscription = formContext.wipSubscription;

    return wipSubscription === null ? (<Card loading />) : (
        <>
            <Button
                className="subscription-scenarios-list__submit-button"
                type="primary"
                icon={<SaveOutlined />}
                onClick={() => formContext.submitUpdate()}
            >
                Mettre à jour
            </Button>
            <ScenariosList
                domainId={aiContext.item?.domain ?? ""}
                subscriptionMode={{
                    idScenarios: wipSubscription.idScenarios ?? [],
                    onToggleScenario: (id: string) =>
                        formContext.onToggleScenario(id),
                }}
            />
        </>
    );
}

export default SubscriptionScenariosList;